import { Image, Page, View } from "@react-pdf/renderer";
import { ReactNode } from "react";
import PrintHeader from "./Header";
import Stamp from "../../../assets/print/stamp.png";
import PrintFooter from "./Footer";

export default function PrintNewPage({
    children,
    orientation = "portrait",
    isStamped = true,
}: {
    children: ReactNode;
    orientation?: "landscape" | "portrait";
    isStamped?: boolean;
}) {
    return (
        <Page
            size="A4"
            orientation={orientation}
            style={{
                paddingHorizontal: 20,
                paddingVertical: 0,
                height: "100%",
                fontSize: "8px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
            }}
        >
            <View wrap={true} style={{ paddingBottom: 120 }}>
                <PrintHeader />
                {children}
            </View>

            {isStamped && (
                <View
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-end",
                        width: "100%",
                    }}
                >
                    <Image src={Stamp} style={{ width: "100px" }} />
                </View>
            )}

            <PrintFooter />
        </Page>
    );
}
